import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { take } from 'rxjs';
import { AvailableLanguages } from '@core/components/header/lang-selection/lang-selection.config';
import { languageSelectors } from '@store/selectors/language.selectors';
import { languageActions } from '@store/actions/language.actions';

@Injectable({
  providedIn: 'root',
})
export class AcTranslationService {
  public readonly langSig = this._store.selectSignal(languageSelectors.currentLanguage);
  public readonly lang$ = this._store.select(languageSelectors.currentLanguage);
  constructor(
    private _translateService: TranslateService,
    private _store: Store<StoreState>,
    private _floatingAlertService: FloatingAlertsService
  ) {}

  changeLang(lang: AvailableLanguages) {
    if (lang !== this._translateService.currentLang) {
      this._translateService
        .use(lang)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this._store.dispatch(languageActions.changeLanguage({ lang }));
          },
          error: () => this._floatingAlertService.error(this._translateService.instant('GENERAL.COULD_NOT_CHANGE_LANGUAGE', { lang })),
        });
    }
  }
  secureInstant<T extends string | Array<string>>(key: T, interpolateParams?: object): T {
    try {
      return this._translateService.instant(key, interpolateParams);
    } catch {
      return key;
    }
  }
}
